export default __webpack_public_path__ + "static/4-ab973cda606731b0d717939e4967ddba.png";